export const of_courier_instructions_displayed_columns_locale = {
  instructionDate: "Date",
  theirReference: "Their reference",
  ourReference: "Your reference",
  destinations: "Destinations",
  instructionTypeId: "Instruction type",
  status: "Status"
};
